var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leave-tab-sections"},[_c('UnplannedLeaveSection'),_c('PlannedLeaveSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }